import React, { useEffect, useState } from "react";
import logo1 from "../../assets/images/Icons_and_images/athees_header_logo.png";
import "@fontsource/manrope";
import "@fontsource/syne";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import { Events, animateScroll as scroll, scrollSpy } from "react-scroll";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    Events.scrollEvent.register("begin", () => {});
    Events.scrollEvent.register("end", () => {});
    scrollSpy.update();

    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);

    return () => {
      Events.scrollEvent.remove("begin");
      Events.scrollEvent.remove("end");
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  return (
    <>
      <Navbar
        expand="lg"
        className="position-sticky top-0 w-100 p-0"
        style={{
          zIndex: 1000,
          background: "#fff",
          // borderBottom: scrolled
          //   ? "1px solid rgba(0,0,0,0.1)"
          //   : "1px solid rgba(0,0,0,0.07)",
          // boxShadow: scrolled ? "0 2px 16px rgba(0,0,0,0.08)" : "none",
          transition: "box-shadow 0.25s ease, border-color 0.25s ease",
        }}
        expanded={menuOpen}
        onToggle={setMenuOpen}
      >
        <Container className="" style={{ maxWidth: 1200 }}>
          {/* ── Logo ── */}
          <Navbar.Brand href="/" className="m-0" style={{ lineHeight: 0 }}>
            <img
              src={logo1}
              alt="Athees Info"
              style={{ height: 52, width: "auto", objectFit: "contain" }}
            />
          </Navbar.Brand>

          {/* ── Mobile toggle ── */}
          <Navbar.Toggle
            aria-controls="main-navbar"
            className="border-0 shadow-none p-1 bg-transparent"
            style={{ outline: "none" }}
          >
            {/* Custom hamburger / X icon */}
            <span
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 5,
                width: 22,
              }}
            >
              {[0, 1, 2].map((i) => (
                <span
                  key={i}
                  style={{
                    display: "block",
                    height: 2,
                    borderRadius: 2,
                    background: "#000",
                    width: i === 1 ? "70%" : "100%",
                    transition: "width 0.2s",
                  }}
                />
              ))}
            </span>
          </Navbar.Toggle>

          {/* ── Nav links ── */}
          <Navbar.Collapse id="main-navbar">
            <Nav
              className="ms-auto align-items-lg-center gap-lg-1"
              style={{ fontFamily: "'Manrope', sans-serif" }}
            >
              <Nav.Link href="/" className="nav-item-link">
                Home
              </Nav.Link>

              <NavDropdown
                title="Our Products"
                id="products-dropdown"
                className="nav-item-link nav-dropdown-custom p-0"
              >
                <NavDropdown.Item href="/Brick">Brick</NavDropdown.Item>
                {/* <NavDropdown.Item href="/CustomerEnquiry">
                  Athees Transporters
                </NavDropdown.Item> */}
                <NavDropdown.Item href="/SchoolPartnership">
                  Sarasu
                </NavDropdown.Item>
              </NavDropdown>

              <Nav.Link href="/AboutUs" className="nav-item-link">
                About Us
              </Nav.Link>
              <Nav.Link href="/ContactUs" className="nav-item-link">
                Contact Us
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <style>{`
        /* Nav link base */
        .nav-item-link {
          font-size: 0.875rem !important;
          font-weight: 600 !important;
          color: #333 !important;
          letter-spacing: 0.02em;
          /*padding: 0.5rem 0.9rem !important;*/
          border-radius: 7px;
          transition: background 0.18s, color 0.18s !important;
          white-space: nowrap;
          text-decoration: none;
        }
        .nav-item-link:hover,
        .nav-item-link:focus {
          background: rgba(0,0,0,0.05) !important;
          color: #111 !important;
        }

        /* Dropdown toggle inherits link style */
        .nav-dropdown-custom > a {
          font-size: 0.875rem !important;
          font-weight: 600 !important;
          color: #333 !important;
          letter-spacing: 0.02em;
          padding: 0.5rem 0.9rem !important;
          border-radius: 7px;
          transition: background 0.18s, color 0.18s !important;
        }
        .nav-dropdown-custom > a:hover {
          background: rgba(0,0,0,0.05) !important;
          color: #111 !important;
        }

        /* Dropdown menu */
        .nav-dropdown-custom .dropdown-menu {
          border: 1px solid rgba(0,0,0,0.08);
          border-radius: 12px;
          box-shadow: 0 8px 32px rgba(0,0,0,0.1);
          padding: 0.5rem;
          min-width: 200px;
          margin-top: 6px;
        }
        .nav-dropdown-custom .dropdown-item {
          font-size: 0.85rem;
          font-weight: 500;
          color: #333;
          border-radius: 7px;
          padding: 0.55rem 0.9rem;
          transition: background 0.15s;
        }
        .nav-dropdown-custom .dropdown-item:hover {
          background: rgba(0,0,0,0.05);
          color: #111;
        }

        /* CTA button */
        .nav-cta-btn {
          display: inline-block;
          background: #1a1a2e;
          color: #fff !important;
          font-size: 0.825rem;
          font-weight: 700;
          letter-spacing: 0.03em;
          padding: 0.55rem 1.4rem;
          border-radius: 50px;
          text-decoration: none;
          transition: background 0.2s, transform 0.2s;
          white-space: nowrap;
        }
        .nav-cta-btn:hover {
          background: #2d2d50;
          transform: translateY(-1px);
          color: #fff !important;
        }

        /* Mobile: full-width collapse */
        @media (max-width: 991px) {
          #main-navbar {
            padding: 1rem 0 0.5rem;
          }
          .nav-item-link,
          .nav-dropdown-custom > a {
            padding: 0.65rem 0.75rem !important;
            border-radius: 8px;
          }
          .nav-cta-btn {
            width: 100%;
            text-align: center;
            border-radius: 10px;
          }
          .nav-dropdown-custom .dropdown-menu {
            box-shadow: none;
            border: none;
            background: rgba(0,0,0,0.03);
            border-radius: 8px;
            margin-top: 2px;
          }
        }
      `}</style>
    </>
  );
}
